import type { ComponentType } from "react";

import { Badge, BadgeColor } from "@prequel/shared-components";

import type { OverviewResourceGroup } from "@/api/import/overview";
import { formatRowCount } from "@/pages/import/OverviewPage/helpers";
import OverviewCard, { OverviewCardEmpty, OverviewCardRow } from "@/pages/import/OverviewPage/OverviewCard";

type ResourcesCardProps = {
  title: string;
  icon: ComponentType<{ className?: string }>;
  group: OverviewResourceGroup;
  listPath: string;
  emptyMessage: string;
};

const ResourcesCard = ({ title, icon: Icon, group, listPath, emptyMessage }: ResourcesCardProps) => {
  const heading = (
    <span className="flex items-center gap-2">
      <Icon className="size-4 text-stone-500" />
      {title}
      <Badge text={`${group.total}`} color={BadgeColor.GRAY} />
    </span>
  );

  return (
    <OverviewCard title={heading} to={listPath} linkLabel={`View all ${title}`}>
      {group.items.length === 0 ? (
        <OverviewCardEmpty message={emptyMessage} />
      ) : (
        group.items.map((item) => (
          <OverviewCardRow
            key={item.id}
            name={item.name}
            providerName={item.provider_name}
            value={formatRowCount(item.total_rows)}
          />
        ))
      )}
    </OverviewCard>
  );
};

export default ResourcesCard;
